import React, { useState } from "react";
import { Button, styled } from "@mui/material";
import { UserLoginContainer } from "./userLoginContainer";
import { KAHUN_PLATFORM, LoginForm } from "./loginForm";

//region [[ Styles ]]
const LoginWidgetView = styled(UserLoginContainer)({
  background: "#ffffff",
  boxShadow: "#8082827d -1px 1px 7px 1px",
  display: "flex",
  "& .forgot-password": {
    "& .MuiButton-label": {
      fontSize: "10px",
    },
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]
export interface LoginWidgetProps {
  onForgotPasswordClick?: () => void;
  onSignUpClick?: () => void;
  onSignIn: (email?: string) => void;
  message?: string;
  hideLogo?: boolean;
  disabled?: boolean;
  keepLoading?: boolean;
  onLoading?: () => void;
  onLoadingDone?: () => void;
  onError?: (error: any) => void;
  socialLoginRedirect?: string;
  enableGoogleLogin?: boolean;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const LoginWidget = ({
  onSignIn,
  onError,
  onLoading,
  onLoadingDone,
  keepLoading,
  message,
  disabled,
  socialLoginRedirect,
  enableGoogleLogin,
  ...props
}: LoginWidgetProps) => {
  const [error, setError] = useState("");

  return (
    <LoginWidgetView error={error} message={message} hideLogo={props.hideLogo}>
      <LoginForm
        onSignIn={onSignIn}
        onError={setError}
        disabled={disabled}
        onLoading={onLoading}
        onLoadingDone={onLoadingDone}
        keepLoading={keepLoading}
        platform={KAHUN_PLATFORM.Extension}
        enableGoogleLogin={enableGoogleLogin}
      />
      {props.onForgotPasswordClick && (
        <span className={"navigation-link forgot-password"}>
          <Button color={"primary"} onClick={props.onForgotPasswordClick}>
            Forgot your password?
          </Button>
        </span>
      )}
      {props.onSignUpClick && (
        <span className={"navigation-link"}>
          Don't have a user yet?
          <Button color={"primary"} onClick={props.onSignUpClick}>
            Sign Up
          </Button>
        </span>
      )}
    </LoginWidgetView>
  );
};
